import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {DiscountCodeApi, DiscountCodeCreateDto, DiscountCodeUpdateDto} from "../../../api";
import ApiService from "../../../services/apiService";
import {loadingSpin, RoutingPaths} from "../../routing/routingContainer";
import DiscountCodeForm from "./discountCodeForm";
import {message} from "antd";

export default function DiscountCodeFormAddContainer() {
    const apiService = useInjection(ApiService);
    const [discountCodeToEdit, setDiscountCodeToEdit] = useState<DiscountCodeUpdateDto | null>(null);
    const navigate = useNavigate();
    const {id} = useParams();

    const onSubmit = useCallback(async (values: DiscountCodeCreateDto | DiscountCodeUpdateDto) => {
        try {
            values.code = values.code?.toUpperCase()
            if (!id) {
                await apiService.getApi(DiscountCodeApi).apiDiscountCodePost(values);
            } else {
                await apiService.getApi(DiscountCodeApi).apiDiscountCodeIdPut(+id, values)
            }

            navigate(RoutingPaths.discountCodeTable.route);
        } catch (e: any) {
            if (e.response?.data.includes("CodeRepeated")) {
                message.error("Podany kod już istanieje, podaj inny");
                return;
            }
            console.log(e);
            return e.response?.data;
        }
    }, [apiService, id]);

    const getDiscountCodeToEdit = useCallback(async () => {
        if (!id) {
            return;
        }
        const response = await apiService.getApi(DiscountCodeApi).apiDiscountCodeIdGet(+id);
        setDiscountCodeToEdit(response.data);

    }, [apiService, id]);

    useEffect(() => {
        getDiscountCodeToEdit();
    }, [getDiscountCodeToEdit]);

    if (id && !discountCodeToEdit) {
        return loadingSpin;
    }

    return <>
        <DiscountCodeForm
            onSubmit={onSubmit}
            saveButtonTitle={"Zapisz"}
            initialValues={discountCodeToEdit!}
        />
    </>
}
